import { lazy } from 'react';

const CharityNIPRoute = lazy(
  () => import(/* webpackChunkName: "CharityNIP" */ '../components/steps/nip-step/NIP'),
);

export default CharityNIPRoute;
